import React, { useRef } from "react";

import { Collapse } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { SectionContainer } from "@app/analytics/components/reports/styles";
import useLocalStorage from "@app/common/hooks/useLocalStorage";
import { getElementPosition } from "@app/common/hooks/useVisibility";

import { StickyContainer } from "@rui/styles";

interface BannerProps {
  onDismiss: () => void;
  show: boolean;
}

interface StickyContainerWithBannerProps {
  children: React.ReactNode;
  banner: React.ForwardRefExoticComponent<
    BannerProps & React.RefAttributes<HTMLDivElement>
  >;
  bannerDismissedLocalStorageKey: string;
  bannerEnabled?: boolean;
}

const FadedBottom = styled(Collapse)({
  height: "16px",
  background: "linear-gradient(to bottom, #FFFFFF, transparent)",
});

const StickyContainerWithBanner = ({
  banner: Banner,
  bannerEnabled = true,
  bannerDismissedLocalStorageKey,
  children,
}: StickyContainerWithBannerProps) => {
  // TODO: support multiple stacked banners
  const bannerRef = useRef<HTMLDivElement>(null);

  const [bannerDismissed, setBannerDismissed] = useLocalStorage(
    bannerDismissedLocalStorageKey,
    false
  );

  const handleDismissBanner = () => setBannerDismissed(true);

  const { top, bottom } = getElementPosition(bannerRef.current);
  const bannerHeight = bottom - top;

  const showBanner = bannerEnabled && !bannerDismissed;

  return (
    <StickyContainer
      sx={{
        top: showBanner ? 0 : 16,
        marginTop: showBanner ? 0 : 2,
        ...(showBanner && {
          "& ~ .report-subsection__scroll-container": {
            scrollMarginTop: `${bannerHeight + 80}px`,
          },
        }),
      }}
    >
      <SectionContainer>
        <Banner
          onDismiss={handleDismissBanner}
          ref={bannerRef}
          show={showBanner}
        />
        <FadedBottom in={showBanner} unmountOnExit />
      </SectionContainer>
      {children}
    </StickyContainer>
  );
};

export default StickyContainerWithBanner;
